import { render, staticRenderFns } from "./UnsavedChangesModal.vue?vue&type=template&id=52f3e8a1&"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports